import styled from "styled-components";

import { Flex, Stack } from "@similarweb/ui-components/foundations";

export const StyledAppsLockedTableOverlayContainer = styled(Stack)`
    position: relative;
    flex: 1 1;
    min-height: 0;
    overflow: hidden;
`;

export const StyledAppsLockedOverlayWrapper = styled(Flex)`
    position: absolute;
    inset: 0;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.85);
    z-index: 10;
    border-radius: 8px;
`;
